import { SearchInput } from "@similarweb/ui-components";
import { StatefulDropdown } from "app/components/dashboard/widget-wizard/components/StatefulDropdown";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { radioItems } from "app/components/React/PopularPagesFilters/popularPagesFilters.config";
import _ from "lodash";
import React from "react";
import { Widget } from "../widget-types/Widget";

export class WebsiteKeywordsDashboardTableWidgetFilters extends React.Component<any, any> {
    protected selectedFilters: any = {};
    protected defaultMetricFilters: any = {};

    constructor(props) {
        super(props);
        this.defaultMetricFilters = {
            TopKeywordsOrganic: "OP;==;0",
            TopKeywordsPaid: "OP;==;1",
        };
        this.state = {
            filter: this.props.widgetFilters.filter,
            clearValue: false,
        };
        this.selectedFilters = {
            filter: this.props.widgetFilters.filter,
            orderBy: this.props.widgetFilters.orderBy || "TotalShare desc",
        };
        this.selectedFilters[this.getSelectedFilter()] = true;
        this.props.changeFilter(this.getSelectedFilters());
    }

    public componentDidUpdate(prevProps) {
        if (this.props.widgetMetric !== prevProps.widgetMetric) {
            this.setState({ clearValue: true });
            setTimeout(() => {
                this.setState({ clearValue: false });
            });
        }
    }

    private getSearchValue() {
        const filterObject: any = Widget.filterParse(this.selectedFilters.filter);
        const filterObjectItem: any = _.find(filterObject, { operator: "contains" });
        return filterObjectItem && filterObjectItem.hasOwnProperty("value")
            ? filterObjectItem.value.replace(/"/g, "")
            : "";
    }

    private getSelectedFilters() {
        const filters = [];
        for (const filter in this.selectedFilters) {
            let _value = this.selectedFilters[filter];
            if (filter === "filter") {
                const _metricFilter = this.defaultMetricFilters[this.props.widgetMetric]
                    ? `${this.defaultMetricFilters[this.props.widgetMetric]},`
                    : "";
                const _textFilter = this.getSearchValue() ? `SearchTerm;contains;"${this.getSearchValue()}",` : "";
                _value = `${_textFilter}${_metricFilter}`;
                _value = _.trim(_value, ",");
                this.setState({ filter: _value });
            }
            filters.push({ name: filter, value: _value });
        }
        return filters;
    }

    private onSearch = (value: string) => {
        const filterValue = Widget.filterStringify({
            SearchTerm: { operator: "contains", value: `"${value}"` },
        });
        this.selectedFilters.filter = filterValue;
        this.props.changeFilter(this.getSelectedFilters());
    };

    private getSelectedFilter() {
        let selectedFilter = radioItems[0].value;
        radioItems.forEach((radioItem) => {
            if (this.props.widgetFilters[radioItem.value] === true) {
                selectedFilter = radioItem.value;
                return;
            }
        });
        return selectedFilter;
    }

    private onSelectOrderBy = (item) => {
        this.selectedFilters.orderBy = item.id;
        this.props.changeFilter(this.getSelectedFilters());
    };

    render() {
        return (
            <div
                key="dynamicFiltersContainer"
                className="filters"
            >
                <div
                    key="searchterm"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.searchterm`}</I18n>
                    </h5>
                    <SearchInput
                        clearValue={this.state.clearValue}
                        defaultValue={this.getSearchValue()}
                        onChange={this.onSearch}
                        debounce={400}
                    />
                </div>
                <div
                    key="orderby"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.orderBy`}</I18n>
                    </h5>
                    <StatefulDropdown
                        key="orderbyFilter"
                        items={[
                            { id: "TotalShare desc", text: "Traffic Share" },
                            { id: "Change desc", text: "Change" },
                        ]}
                        selectedId={this.selectedFilters.orderBy}
                        onSelect={this.onSelectOrderBy}
                    />
                </div>
            </div>
        );
    }
}
